import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { MapValidator } from '@colonist/game-mechanic-validators';
export const useMapValidator = ()=>{
    const mapState = useGameStore((state)=>state.gameState.mapState);
    return useMemo(()=>new MapValidator(mapState), [
        mapState
    ]);
};
